import {
  CONSENT_PROMOTION_LAYER_POPUP,
  FIRST_MONTH_PROMOTION_LAYER_POPUP,
  POPUP_STANDARD,
} from '@/common/resources/const'

// full page popup
import PopupConsentPromotion from '@/views/popup/frames/PopupConsentPromotion.vue'
import FirstMonthPromotion from '@/views/popup/popups/FirstMonthPromotion.vue'
import PopupStandard from '@/views/popup/frames/PopupStandard.vue'

import { onMounted, onUnmounted, shallowRef, ref } from 'vue'
import { EventBus } from '@/components/eventbus/EventBus'

export const useLayerPopupLoader = () => {
  const layerPopup = shallowRef(null)
  const isPopupOpen = ref(false)
  const payloads = ref({})

  /**
   * /popup/frames 안에 있는 컴포넌트만 생성 함.
   * 그 외에는 프레임이 아니라고 간주, 프레임을 따로 만들어야 함
   * @param layerPopupName
   * @returns {unknown}
   */
  const getLayerPopup = (layerPopupName) => {
    switch (layerPopupName) {
      case CONSENT_PROMOTION_LAYER_POPUP:
        layerPopup.value = PopupConsentPromotion
        break

      case POPUP_STANDARD:
        layerPopup.value = PopupStandard
        break

      case FIRST_MONTH_PROMOTION_LAYER_POPUP:
        layerPopup.value = FirstMonthPromotion
        break
    }
    return layerPopup.value
  }

  /**
   * set layer popup
   * @param payload
   * @param name
   */
  const setPopup = (payload, name) => {
    const { isOpen = false, ...rest } = payload
    payloads.value = rest
    isPopupOpen.value = isOpen
    getLayerPopup(name)
  }

  onMounted(() => {
    EventBus.$on(CONSENT_PROMOTION_LAYER_POPUP, (payload = { isOpen: false }) =>
      setPopup(payload, CONSENT_PROMOTION_LAYER_POPUP),
    )

    EventBus.$on(POPUP_STANDARD, (payload = { isOpen: false }) =>
      setPopup(payload, POPUP_STANDARD),
    )

    EventBus.$on(
      FIRST_MONTH_PROMOTION_LAYER_POPUP,
      (payload = { isOpen: false }) =>
        setPopup(payload, FIRST_MONTH_PROMOTION_LAYER_POPUP),
    )
  })

  onUnmounted(() => {
    EventBus.$off(CONSENT_PROMOTION_LAYER_POPUP)
    EventBus.$off(POPUP_STANDARD)
    EventBus.$off(FIRST_MONTH_PROMOTION_LAYER_POPUP)
  })

  return {
    layerPopup,
    isPopupOpen,
    payloads,
    getLayerPopup,
  }
}
